
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/llm-development-services",
      function () {
        return require("private-next-pages/llm-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/llm-development-services"])
      });
    }
  